const items = [
  "Driven With Purpose",
  "Flat 9% Fee",
  "Owner-Operators First",
  "No Forced Loads",
  "Weekly Revenue Summaries",
  "24/7 Dispatch Support",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div className="border-y border-white/10 bg-[#0B0B0B] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-mono text-xs sm:text-sm uppercase tracking-[0.35em] text-neutral-400"
              >
                <span className="px-8">{item}</span>
                <span className="text-white/40">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
